import { cleanDialogStack } from '@patrianna/dialog-manager'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'

import Button from 'components/Button'
import useMenuVisibility from 'hooks/useMenuVisibility'
import common from 'prismic-translates/common.json'
import { useReturnAfterVerification } from 'src/hooks/useReturnAfterVerification'
import { useAppSelector } from 'store/hooks'
import { getKycStatusSelector } from 'store/modules/kyc/selectors'

import classes from './styles.module.scss'

const t = getTranslationFromJson([common])

export default function BackButton() {
  const kycStatus = useAppSelector(getKycStatusSelector)
  const { getVerificationFrom, handleOpenAfterClosingSubmitDocumentsDialog } = useReturnAfterVerification()
  const isKycConfirmed = kycStatus === 'confirmed'
  const { isMenuOpened, toggleMenu } = useMenuVisibility()
  const verificationFrom = getVerificationFrom()

  const onClick = () => {
    cleanDialogStack()
    handleOpenAfterClosingSubmitDocumentsDialog(verificationFrom)

    if (isMenuOpened) {
      toggleMenu(false)
    }
  }

  if (!isKycConfirmed) {
    return null
  }

  return (
    <Button data-test='verifications-proceed-lobby-btn' onClick={onClick} className={classes.button}>
      {t('understood')}
    </Button>
  )
}
